import React from 'react'
import { DialogContent } from '@common/material'
import { ModalDialogContainer } from '@common/modal'
import { TaskDetails } from '../TaskDetails'

type TaskDetailsModalProps = {
  taskId: number
}

export const TaskDetailsModal: React.FC<TaskDetailsModalProps> = ({
  taskId,
}) => {
  return (
    <ModalDialogContainer
      PaperProps={{
        sx: {
          maxHeight: '99%',
          maxWidth: 'md',
        },
      }}
    >
      <DialogContent
        sx={{
          overflow: 'auto',
          height: '100vh',
          flexDirection: 'column',
          my: '20px',
          py: 0,
        }}
      >
        <TaskDetails taskId={taskId} isModal />
      </DialogContent>
    </ModalDialogContainer>
  )
}
